<template>
  <v-col>
    <v-row class="mb-8">
      <v-btn
        color="primary"
        @click="CHANGE_CELLULARI_COMPONENT('Index')"
      >Indietro</v-btn>
    </v-row>
    <v-row
      align="center"
      justify="center"
    >
      <v-card min-width="100%">
        <!-- #datepicker -->
        <v-col>
          <v-row class="px-4">
            <v-col>
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="true"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="today"
                    label="Data di acquisto"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="today"
                  no-title
                  scrollable
                  actions
                  locale="it-IT"
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    color="primary"
                    @click="menu = false"
                  >OK</v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col
              class="flex flex-col items-bottm"
              md="1"
            >
              <v-btn
                style="width: 100%;"
                color="primary"
                @click="today = new Date().toISOString().substr(0, 10)"
              >Oggi</v-btn>
            </v-col>
          </v-row>
        </v-col>
        <v-form
          ref="form"
          v-model="valid"
          :lazy-validation="true"
          autocomplete="off"
        >
          <v-card-title class="primary--text">
            <v-col>
              <v-row>
                <v-col>
                  <v-autocomplete
                    label="Ricerca smartphone"
                    v-model="model"
                    :search-input.sync="search"
                    :items="searchItems"
                    :loading="isLoading"
                    hide-no-data
                    hide-selected
                    item-text="text"
                    item-value="id"
                    return-object
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-col>
          </v-card-title>
          <v-card-text>

            <v-col>
              <v-row>
                <v-col>
                  <v-text-field
                    label="Marca"
                    v-model="newSmartphone.brand"
                    :rules="[rules.required]"
                    required
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    label="Modello"
                    v-model="newSmartphone.model"
                    :rules="[rules.required]"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field
                    label="Colore"
                    v-model="newSmartphone.color"
                    :rules="[rules.required]"
                    required
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    label="HDD"
                    v-model="newSmartphone.disk_space"
                    :rules="[rules.required]"
                    required
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    label="RAM"
                    v-model="newSmartphone.ram"
                    :rules="[rules.required]"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-divider />
              <v-row>
                <v-col>
                  <v-text-field
                    label="IMEI"
                    v-model="newSmartphone.serial_number"
                    :rules="[rules.required]"
                    required
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    label="EAN"
                    v-model="newSmartphone.ean"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-select
                    label="Stato"
                    :items="states"
                    @change="setState"
                    :rules="[rules.required]"
                    required
                  ></v-select>
                </v-col>
                <v-col>
                  <v-text-field
                    label="Grado"
                    v-model="newSmartphone.grade"
                    :readonly="gradeReadOnly"
                    :rules="[rules.required]"
                    required
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-select
                    label="Fornitore"
                    :items="suppliers"
                    item-text="name"
                    item-value="id"
                    v-model="newSmartphone.supplier_id"
                    :rules="[rules.required]"
                    required
                  ></v-select>
                </v-col>
              </v-row>
              <v-row>
                <!-- <v-col>
                  <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="today"
                        label="Data di acquisto"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="today"
                      no-title
                      scrollable
                      actions
                      locale="it-IT"
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="menu = false"
                      >Annulla</v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="menu = false"
                      >OK</v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col> -->
                <v-col>
                  <v-text-field
                    label="Descrizione"
                    v-model="newSmartphone.description"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field
                    label="Costo"
                    type="number"
                    v-model="newSmartphone.cost"
                    :rules="[rules.required]"
                    required
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    label="Prezzo"
                    type="number"
                    v-model="newSmartphone.price"
                    :rules="[rules.required]"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-card-text>
          <v-card-actions>
            <v-col>
              <v-row>
                <v-col>
                  <v-btn
                    :disabled="!valid"
                    color="success"
                    class="mr-4"
                    @click="submit"
                  >
                    Inserici Smartphone
                  </v-btn>

                  <v-btn
                    color="error"
                    class="mr-4"
                    @click="reset"
                  >
                    Reset Modulo
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-row>
    <snack-notification :snack="snack" />
  </v-col>
</template>

<script>
  import axios from 'axios'
  import { mapMutations } from 'vuex'

  import SnackNotification from './../../SnackNotification'

  export default {
    name: 'Insert',
    components: {
      SnackNotification
    },
    data() {
      return {
        newSmartphone: {
          brand: null,
          model: null,
          disk_space: null,
          ram: null,
          color: null,
          description: null,
          serial_number: null,
          ean: null,
          cost: null,
          price: null,
          grade: null,
          is_new: null,
          is_art_17: null,
          smartphone_id: null,
          posix: this.posix,
          supplier_id: null
        },
        menu: false,
        valid: false,
        today: new Date().toISOString().substr(0, 10),
        todayBackup: new Date().toISOString().substr(0, 10),
        search: '',
        model: null,
        searchItems: [],
        isLoading: false,
        suppliers: [],
        states: [
          'Smartphone Nuovo',
          'Smartphone Usato Art.17',
          'Smartphone Usato Art.36'
        ],
        gradeReadOnly: false,
        snack: {
          error: null,
          visible: null,
          message: null
        },
        rules: {
          required: value => !!value || 'Campo obbligatorio.',
        },
        config: {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
          }
        },
      }
    },
    methods: {
      ...mapMutations([
        'CHANGE_CELLULARI_COMPONENT'
      ]),
      async getSuppliers() {
        let { data } = await axios.get(`${process.env.VUE_APP_API}/suppliers`, this.config)

        this.suppliers = data
      },
      setState(value) {
        if (value === 'Smartphone Nuovo') {
          this.newSmartphone.is_new = true
          this.newSmartphone.is_art_17 = true
          this.newSmartphone.grade = 'Nuovo'
          this.gradeReadOnly = true
        } else if (value === 'Smartphone Usato Art.17') {
          this.newSmartphone.is_new = false
          this.newSmartphone.is_art_17 = true
          this.newSmartphone.grade = this.newSmartphone.grade === 'Nuovo' ? null : this.newSmartphone.grade
          this.gradeReadOnly = false
        } else if (value === 'Smartphone Usato Art.36') {
          this.newSmartphone.is_new = false
          this.newSmartphone.is_art_17 = false
          this.newSmartphone.grade = this.newSmartphone.grade === 'Nuovo' ? null : this.newSmartphone.grade
          this.gradeReadOnly = false
        }
      },
      async submit() {
        if (this.$refs.form.validate()) {

          this.snack = Object.assign({}, {
            error: null,
            visible: null,
            message: null
          })

          const { data } = await axios.post(`${process.env.VUE_APP_API}/smartphones/create`, this.newSmartphone, this.config)

          if (data.status) {

            this.snack = Object.assign({}, {
              visible: true,
              error: false,
              message: 'Articolo salvato correttamente!'
            })
          } else {

            this.snack = Object.assign({}, {
              visible: true,
              error: true,
              message: 'Errore nel salvataggio.'
            })
          }

        }
      },
      reset() {

        this.$refs.form.reset()
        this.today = this.todayBackup
        console.log('reset', this.today, this.todayBackup)
      },
    },
    watch: {
      async search(val) {
        if (this.isLoading) return
        if (this.model) return

        this.isLoading = true

        const body = {
          term: val
        }

        const { data } = await axios.post(`${process.env.VUE_APP_API}/smartphones/search-model`, body, this.config)

        this.searchItems = data.map(el => {

          el.text = `${el.brand} ${el.model} ${el.color}, ${el.disk_space} / ${el.ram}`

          return el
        })

        this.isLoading = false
      },
      model(val) {
        if (val) {
          this.newSmartphone.smartphone_id = val.id,
            this.newSmartphone.brand = val.brand,
            this.newSmartphone.model = val.model,
            this.newSmartphone.disk_space = val.disk_space,
            this.newSmartphone.ram = val.ram,
            this.newSmartphone.color = val.color,
            this.newSmartphone.description = val.description
        }
      },
      today: {
        handler(val) {
          console.log('today', val)
          if (val) {
            this.todayBackup = val
            this.newSmartphone.posix = Math.round(new Date(val).getTime() / 1000)
          } else {
            this.today = this.todayBackup
            this.newSmartphone.posix = Math.round(new Date(this.today).getTime() / 1000)
          }
        },
        immediate: true
      }
    },
    mounted() {
      this.getSuppliers()
    }
  }
</script>

<style>
</style>